// removed by extract-text-webpack-plugin
module.exports = {"solved":"Solved__solved___1N5Be","background":"Solved__background___11zYc","heading":"Solved__heading___MtStp","prizes":"Solved__prizes___1kY8B","prize":"Solved__prize___3Bctp","body":"Solved__body___3aqgk","buttons":"Solved__buttons___2lHzU","button":"Solved__button___FxohZ","oneMore":"Solved__oneMore___2cXdZ","nextLevel":"Solved__nextLevel___3c-Fk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Solved/Solved.css
// module id = 873
// module chunks = 0